import localforage from 'localforage';

export function createOfflineDatabase(): { offlineDatabase: LocalForage, databaseCache: LocalForage } {
  localforage.config({
    driver      : localforage.INDEXEDDB,
    name        : 'retrofit',
    storeName   : 'db',
    description : 'retrofit database'
  });
  return  {
    offlineDatabase: localforage.createInstance({ name: 'db' }),
    databaseCache:  localforage.createInstance({ name: 'cache' }),
  }
}
